import { watch } from 'vue'
import hemisphereService from '@/services/hemisphere.service'
import { useSession } from '@/composables/auth'

const INTERNAL = {
  buildingId: undefined as string | undefined,
  pendingPromise: undefined as Promise<string | undefined> | undefined
}

// clear data when we disconnect
const { loggedIn } = useSession()
watch(loggedIn, (current) => {
  if (!current) {
    INTERNAL.pendingPromise = undefined
    INTERNAL.buildingId = undefined
  }
})

export function useCurrentBuildingId() {
  function getCurrentBuildingId(): Promise<string | undefined> {
    if (INTERNAL.buildingId) {
      return Promise.resolve(INTERNAL.buildingId)
    }

    if (!INTERNAL.pendingPromise) {
      INTERNAL.pendingPromise = (async () => {
        const response = await hemisphereService.getMyAuthorizations()
        // don't store the buildingId if a logout happened while
        // requesting the buildingId
        if (!INTERNAL.pendingPromise) {
          return undefined
        }
        INTERNAL.buildingId = response.data[0].building?.id
        INTERNAL.pendingPromise = undefined
        return INTERNAL.buildingId
      })()
    }

    return INTERNAL.pendingPromise
  }

  return getCurrentBuildingId
}
